import DetailsCard from './cards/DetailsCard';
import HandedOffCard from './cards/HandedOffCard';
import type { MappingRuleChat } from './useMappingRuleChat';
import type { MappingRuleStepKind } from './types';

// One card per step, keyed off the step stamped on the message — same shape as
// SmartImportCard/DirectAllocationCard.
export default function MappingRuleCard({
	step,
	chat,
}: {
	step: MappingRuleStepKind;
	chat: MappingRuleChat;
}) {
	if (step !== chat.step) {
		return null;
	}
	return step === 'details' ? <DetailsCard chat={chat} /> : <HandedOffCard chat={chat} />;
}
